import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const TrendHigherIcon = () => {
  return (
    <SvgIcon viewBox={'0 0 12 9'}>
      <path d="M6 0L12 8.30769H0L6 0Z" />
    </SvgIcon>
  );
};

export { TrendHigherIcon };
